<div class="relative">
  <fin-content-image
    class="block image-height"
    [imageData$]="imageData$"
    [aspectRatio$]="imageAspectRatio$"
    [isLazyLoad]="false"
    [fetchPriority]="FetchPriorityEnum.high"
  />
  <div class="text-block absolute" *ngIf="teaserTitle$ | async">
    <h2
      class="inline-block font-heading-1 nordic-blue-900-text text-icon-primary white-bg surface-primary pr-xxsmall text-block-width font-headline-medium"
    >
      {{ teaserTitle$ | async }}
    </h2>
  </div>
</div>
<div
  class="pr-xsmall-x white-bg surface-primary nordic-blue-900-text text-icon-primary"
  *ngIf="teaserText$ | async as tt"
>
  <span class="ingress" [innerHTML]="tt | finSafe: 'html'"></span>
</div>
